<template>
  <div class="row export">
    <label class="text">{{ $t('action.generatePDF') }}</label>
    <HKLSelect
      :value="selectedValue || undefined"
      :options="exportHklOptions"
      dropdownClassName="export-pdf-dropdown"
      :showSearch="false"
      placeholder=""
      @change="exportPDF"
    />
  </div>
</template>

<script>
import HKLSelect from '@/controls/Select/HKLSelect.vue'

export default {
  name: 'ExportPdfWithOptions',
  components: {
    HKLSelect,
  },

  props: {
    options: {
      type: Array,
      default: () => [],
    },
  },

  data () {
    return {
      selectedValue: undefined,
    }
  },

  computed: {
    exportHklOptions () {
      return (this.options || []).map((opt) => {
        const value = typeof opt === 'string'
          ? opt
          : (opt.val != null ? opt.val : (opt.value != null ? opt.value : opt))
        const name = typeof opt === 'string'
          ? opt
          : (opt.label != null ? opt.label : (opt.name != null ? opt.name : String(value)))
        return { name, value }
      })
    },
  },

  methods: {
    exportPDF (value) {
      if (value) {
        this.$emit('export:pdf', value)
        this.selectedValue = undefined
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.export {
  width: 150px !important;
  min-width: 150px;
  height: 40px;
  position: relative;
  border: solid 1px #B5B5B5;
  background-color: #fff;

  .text {
    position: relative;
    z-index: 1;
    font-weight: 400;
    color: #0C3A58;
    height: 40px;
    line-height: 29px;
    padding: 6px 1px 6px 10px;
    margin: 0;
    pointer-events: none;
  }

  & ::v-deep .hkl-select {
    position: absolute;
    inset: 0;
    border: none;
    width: 100%;
    min-width: 100%;
    background-color: transparent;

    .ant-select-selection {
      border: none;
      background-color: transparent;
      box-shadow: none;
    }

    .ant-select-selection__rendered {
      display: none;
    }
  }

  & ::v-deep .export-pdf-dropdown {
    width: 150px !important;
    min-width: 150px;
  }
}
</style>
